import React, { useEffect, useState } from 'react';
import { useEasybase } from 'easybase-react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Typography } from '@material-ui/core';

const KursMigliederDialog = (props) => {
  const [dialogOpen, setDialogOpen] = useState(true);
  const [buchListe, setBuchListe] = useState([]);
  const [neue, setNeue] = useState('');

  const { db, e } = useEasybase();
  const mounted = () => {
    db("BUCHUNG").return().where(e.eq('kursid', props.edKey)).limit(100).all()
      .then(buchListe => {
        // eslint-disable-next-line
        setBuchListe(buchListe);
      });
  };

  useEffect(() => {
    mounted();
    // eslint-disable-next-line
  }, []);


  const handleClose = () => {
    setDialogOpen(false);
    if (props.fertig !== null) {
      props.fertig(false);
    }
  };

  const onEraseWer = async (event) => {
    const index = parseInt(event.currentTarget.value);
    const delRes = await db("BUCHUNG").delete().where(
      e.and(
        e.eq('_key', buchListe[index]._key)
      )).all();
    console.log("Delete " + buchListe[index]._key + "liefert:" + delRes);
    setDialogOpen(false);
    props.fertig(true);
  };

  const onSafeNeue = async (event) => {
    await db("BUCHUNG").insert({
      wer: neue,
      kursid: "" + props.edKey,
      sr: props.edSr
    }).one().then(insRes => {
      console.log("Insert liefert:" + insRes);
      setDialogOpen(false);
      props.fertig(true);
    });
  };

  const onChangeNeue = (e) => {
    e.preventDefault();
    setNeue(e.target.value);
  }

  return (
    <>
      <Dialog open={dialogOpen} onClose={handleClose} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-title">Kurs bearbeiten: {props.edName}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography variant="body1" color="primary">{props.edDatum} {props.edZeit}</Typography>
            Unten finden sich die Teilnehmer und Teilnehmerinnen. Ein Klick bucht sie aus.
          </DialogContentText>
          <Box m={1}>
            {buchListe.map((buchung, index) =>
              <Button value={"" + index} variant="contained" onClick={onEraseWer}>{buchung.wer}</Button>
            )}
          </Box>
          <Box m={1}>
            <TextField id="neue" value={neue} fullWidth label="Neue Adresse" onChange={onChangeNeue} />
            <Button variant="contained" disabled={neue.length <= 3 || neue.indexOf('@') < 1} onClick={onSafeNeue}>Speichern</Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose}>Abbrechen</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default KursMigliederDialog;
